import { IAppState } from '../common/state';

export function selectNotAvailablePopup(state: IAppState) {
  return state.notAvailablePopup;
}
